import moment from "moment";
import DatePicker from "react-datepicker";
import BaseComponent from "../../baseComponent.js";
import MonthPicker from "./monthPicker.jsx";
import YearPicker from "./yearPicker.jsx";
import styles from "./date-picker.scss";

export default class Filter extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange(type) {
    var _this = this;
    return function (date) {
      _this.props.onDateFilterChange(type, date.endOf("day"));
    }
  }

  componentDidMount() {
    $(this.refs.container).find("select").material_select();
    $(this.refs.periodType).on("change", this.handlePeriodTypeChange);
  }

  handlePeriodTypeChange(event) {
    this.props.onPeriodTypeChange(event.target.value);
  }

  render() {
    var fromDatePicker, toDatePicker;

    switch (this.props.periodType) {
      case "daily": {
        fromDatePicker = <DatePicker
          selected={this.props.fromDate}
          minDate={moment("2000-01-01")}
          maxDate={moment(this.props.toDate).add(-1, "days")}
          onChange={this.handleChange("fromDate")}/>;
        toDatePicker = <DatePicker
          selected={this.props.toDate}
          minDate={this.props.fromDate}
          maxDate={moment()}
          onChange={this.handleChange("toDate")}/>;
        break;
      }
      case "monthly": {
        fromDatePicker = <MonthPicker selected={this.props.fromDate}
                                      minDate={moment("2000-01-01")}
                                      maxDate={this.props.toDate}
                                      type="start"
                                      onChange={this.handleChange("fromDate")}/>;
        toDatePicker = <MonthPicker selected={this.props.toDate}
                                    minDate={this.props.fromDate}
                                    maxDate={moment()}
                                    type="end"
                                    onChange={this.handleChange("toDate")}/>;
        break;
      }
      case "yearly": {
        fromDatePicker = <YearPicker year="2016"/>;
        toDatePicker = <YearPicker year="2017"/>;
        break;
      }
    }

    return (
      <div className="profile-filters" ref="container">
        <select className="profile-filters__activity-type" defaultValue="">
          <option value="0">MY ACTIVITY</option>
          <option value="1">MY ORGANIZATION ACTIVITY</option>
        </select>

        <select className="profile-filters__period" ref="periodType"
                value={this.props.periodType}
                onChange={this.handlePeriodTypeChange}>
          <option value="daily">DAILY</option>
          <option value="monthly">MONTHLY</option>
          <option value="yearly">YEARLY</option>
        </select>
        <div className="profile-filters__date">
          <div className="profile-filters__label">FROM</div>
          {fromDatePicker}
        </div>

        <div className="profile-filters__date">
          <div className="profile-filters__label">TO</div>
          {toDatePicker}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/common/filter.jsx